import { BaseHelper } from 'services/BaseGraphQLAPIHelper';

const LEVEL_SIMPLE_NODE = `{
  id
  pk
  levelName
  levelRank
}`;

const LEVEL_LIST_NODE = `{
  id
  pk
  active
  levelName
  isLowestLevel
  levelRank
  enableCheckTargetTotalPointsEarned
  targetTotalPointsEarned
  enableCheckAccumulatedSpendingInAPeriod
  accumulatedSpendingInThePeriod
  accumulatedSpendingInXDay
  enableCheckSpendingInOnePurchase
  spendingInOnePurchase
  renewLogic
  downgradeLogic
  renewForceDowngradeLevel {
    pk
    levelName
  }
  lastModifiedDate
  levelCalculationSource
}`

const LEVEL_NODE = `{
  id
  pk
  active
  levelName
  foregroundElementColor
  membershipCardBackgroundType
  membershipCardBackgroundColor
  cardLandscapeBackgroundImageInApp
  cardPortraitBackgroundImageInApp
  cardLandscapeBackgroundImageInWeb
  cardPortraitBackgroundImageInWeb
  hideLevelDetailsAndUpgradeTips
  isLowestLevel
  levelRank
  enableCheckTargetTotalPointsEarned
  targetTotalPointsEarned
  enableCheckAccumulatedSpendingInAPeriod
  accumulatedSpendingInThePeriod
  accumulatedSpendingInXDay
  enableCheckSpendingInOnePurchase
  spendingInOnePurchase
  renewLogic
  enableCheckCalculationSourceValueWithinPeriodForRetain
  retainRequiredValue
  enableCheckEffectiveTransactionTimesWithinPeriod
  requiredTransactionTimes
  minimumAmountOfOneTransactionForRenew
  downgradeLogic
  minimumDowngradeLevel {
    pk
    levelName
  }
  renewForceDowngradeLevel {
    pk
    levelName
  }
  translations {
    edges {
      node {
        pk
        language
        levelName
      }
    }
  }
  creationDate
  lastModifiedDate
  lastModifiedBy
  lastModifiedByAdmin {
    id
    pk
    username
  }
  levelCalculationSource
}`

export const getLevels = (afterCursor, moreSearch) => {
  const isListApi = moreSearch?.isListApi;
  let filter = '';
  const filterName = moreSearch?.filterName || moreSearch?.search;
  if (filterName) {
    filter += `, name:"${filterName}"`;
  }
  if (moreSearch?.is_active) {
    filter += `, isActive: ${moreSearch.is_active}`;
  } else if (!isListApi) {
    filter += ", isActive: true";
  }

  const orderBy = moreSearch?.sort || '-levelRank';

  const query = `query Levels {
    levels(first: 20, orderBy: "${orderBy}"${filter}) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node ${
          isListApi
          ? LEVEL_LIST_NODE
          : LEVEL_SIMPLE_NODE
        }
      }
    }
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getLevel = (id) => {
  const query = `query level {
    level(id: "${id}") ${LEVEL_NODE}
  }`

  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
}

export const createOrUpdateLevel = (payload) => {
  const actionType = payload.id ? "Update" : "Create"
  const query = `
    mutation ${actionType}Level($input:${actionType}LevelInput!) {
      ${actionType.toLocaleLowerCase()}Level(input: $input) {
        node {
          pk
        }
        success
        errors {
          field
          messages
        }
      }
    }
  `;
  const variables = {
    input: payload,
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
}


const LEVEL_DISCOUNT_LIST_NODE_CONTENT = `{
  id
  pk
  discount
  freeDeliveryOnShopfify
  level {
    id
    pk
    levelName
  }
  creationDate
  lastModifiedDate
  lastModifiedBy
  lastModifiedByAdmin {
    id
    pk
    username
  }
}`

const LEVEL_DISCOUNT_DETAIL_NODE_CONTENT = `{
  id
  pk
  discount
  freeDeliveryOnShopfify
  level {
    id
    pk
    levelName
  }
  creationDate
  lastModifiedDate
  lastModifiedBy
  lastModifiedByAdmin {
    id
    pk
    username
  }
  levelBenefits {
    pk
    title
    content
    highlight
    displayOrder
    translations {
      edges {
        node {
          pk
          language
          title
          content
        }
      }
    }
  }
}`;


export const getLevelDiscountList = (afterCursor, moreSearch) => {
  let filter = '';
  if (moreSearch.filterName || moreSearch.search) {
    filter = `, nameIcontains:"${moreSearch.filterName || moreSearch.search}"`;
  }

  let orderBy = moreSearch.rank ? '-pk' : 'pk';

  const query = `{
    levelDiscounts(first: ${moreSearch?.isAll ? 100 : 20}, after:"${afterCursor}", orderBy:"${orderBy}"${filter}) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node ${LEVEL_DISCOUNT_LIST_NODE_CONTENT}
      }
    }
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getLevelDiscount = (id) => {
  const query = `{
    levelDiscount(id: "${id}") ${LEVEL_DISCOUNT_DETAIL_NODE_CONTENT}
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const updateLevelDiscount = (values) => {
  const action = 'Update';
  const query = `
    mutation ${action}LevelDiscount($input: ${action}LevelDiscountInput!) {
      ${action.toLowerCase()}LevelDiscount(input: $input) {
        success
        node ${LEVEL_DISCOUNT_DETAIL_NODE_CONTENT}
        errors {
          field
          messages
        }
      }
    }
  `;
  const variables = { input: values };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getLevelRules = () => {
  const query = `{
    levelRules(first: 100, orderBy:"displayOrder") {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          pk
          title
          content
          displayOrder
          translations {
            edges {
              node {
                pk
                language
                title
                content
              }
            }
          }
        }
      }
    }
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
}

export const updateLevelRules = (valueList) => {
  const query = `
    mutation UpdateLevelRules($input: UpdateLevelRulesInput!) {
      updateLevelRules(input: $input) {
        success
        errors {
          field
          messages
        }
      }
    }
  `;
  const variables = { input: valueList };
  return BaseHelper.callGraphQLAPI({ query, variables });
}

export const getRetainMembershipTips = () => {
  const query = `{
    retainMembershipTips(first: 1) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          pk
          title
          description
          translations {
            edges {
              node {
                pk
                language
                title
                description
              }
            }
          }
        }
      }
    }
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
}

export const updateRetainMembershipTips = (values) => {
  const query = `
    mutation UpdateRetainMembershipTips($input: UpdateRetainMembershipTipsInput!) {
      updateRetainMembershipTips(input: $input) {
        success
        errors {
          field
          messages
        }
      }
    }
  `;
  const variables = { input: values };
  return BaseHelper.callGraphQLAPI({ query, variables });
}

export const updateLevelBenefits = (valueList) => {
  const query = `
    mutation UpdateLevelBenefits($input: UpdateLevelBenefitsInput!) {
      updateLevelBenefits(input: $input) {
        success
        errors {
          field
          messages
        }
      }
    }
  `;
  const variables = { input: valueList };
  return BaseHelper.callGraphQLAPI({ query, variables });
}

export const getLevelGlobalSetting = () => {
  const query = `{
    levelGlobalSettings(first: 1) {
      edges {
        node {
          pk
          membershipPeriodMode
          fixedPeriodStartDatetime
          dynamicDuration
          extendMembershipOnUpgrade
          levelCalculationSource
          handlingCalculationSourceAfterRenewal
          enableEasyUpgrade
          handlingExpiredPeriodXDayAfterRefund
        }
      }
    }
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
}

export const updateLevelGlobalSetting = (payload) => {
  const query = `
    mutation UpdateLevelGlobalSetting($input: UpdateLevelGlobalSettingInput!) {
      updateLevelGlobalSetting(input: $input) {
        success
        errors {
          field
          messages
        }
      }
    }
  `;
  const variables = { input: payload };
  return BaseHelper.callGraphQLAPI({ query, variables });
}
